import { useState } from "react"
import { PageCard } from "../../../../../styles/CommonStyles"
import Tabbar from "../../../../common/tabs/Tabbar"
import UserBalanceHistory from "./BalanceHistory"
import AllCards from "../../../reports/cards/AllCards"
import UserCardBalance from "./CardBalance/UserBalances"

const tabs = ['balance-history', 'user-cards', 'user-balance']

const UserCards = ({ user }) => {
    const [cardsTab, setCardsTab] = useState("balance-history")

    return (
        <PageCard className="overflow-hidden">
            <Tabbar
                active={tabs.indexOf(cardsTab) + 1}
                tabs={tabs}
                onTabClicked={(idx) => setCardsTab(tabs[idx - 1])}
            />
            {cardsTab === "balance-history" &&
                <UserBalanceHistory userId={user?._id} />
            }
            {cardsTab === "user-cards" &&
                <AllCards userId={user?._id} />
            }
            {cardsTab === "user-balance" &&
                <UserCardBalance userId={user?._id} />
            }
        </PageCard>

    )
}

export default UserCards